import { format } from "mathjs";

export const formatToCurrency = (number) => {
  if (!isNaN(parseFloat(number).toFixed(2))) {
    // const rounded = Math.floor(number * 100) / 100;
    return format(number, { notation: "fixed", precision: 2 });
  }
  return 0;
};
